import { Component, Input, OnDestroy } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { AbstractComponentWithScrollContainer } from 'src/app/shared/components/abstract-component-with-scroll-container';
import { KeyboardShowHideService } from 'src/app/shared/services/keyboard-show-hide.service';
import { ScrollService } from 'src/app/shared/services/scroll.service';

import { TaskProcessContext } from '../shared/task-process-context.class';
import { TaskProcessModalsService } from '../shared/task-process-modals.service';
import { TaskProcessService } from '../shared/task-process.service';

@Component({
  selector: 'app-annotations-modal',
  templateUrl: './annotations-modal.component.html',
  styleUrls: ['./annotations-modal.component.scss'],
})
export class AnnotationsModalComponent extends AbstractComponentWithScrollContainer implements OnDestroy {
  @Input() taskId: number;
  @Input() annotations: any[];
  @Input() taskProcessContext: TaskProcessContext;

  newAnnotationText = '';
  isSubmitting = false;

  constructor(
    private taskProcessService: TaskProcessService,
    private taskProcessModalsService: TaskProcessModalsService,
    private scrollService: ScrollService,
    private keyboardShowHideService: KeyboardShowHideService
  ) {
    super();
  }

  get canPutOnHold() {
    return !this.taskProcessContext.isReadOnlyMode;
  }

  ionViewDidEnter() {
    this.scrollService.scrollToBottom(this);
  }

  ngOnDestroy() {
    this.keyboardShowHideService.clearScrollElementAndTextInputElement();
  }

  dismissModal() {
    this.taskProcessModalsService.dismissTaskProcessPageModal();
  }

  onTextareaClicked(event) {
    this.keyboardShowHideService.setScrollElementAndTextInputElement(this.scrollContainer, event.target);
  }

  onAnnotate(putOnHold: boolean) {
    this.isSubmitting = true;
    this.taskProcessService
      .annotateTask(this.taskId, {
        comment: this.newAnnotationText,
        parent_id: null,
        put_on_hold: putOnHold,
      })
      .pipe(finalize(() => (this.isSubmitting = false)))
      .subscribe(() => this.afterAnnotate(putOnHold));
  }

  private afterAnnotate(putOnHold: boolean) {
    if (putOnHold) {
      this.dismissModal();
      this.taskProcessContext.backToTaskList();
    } else {
      this.newAnnotationText = ''; // Clear annotation text area
      // Scroll to bottom again after the new annotation is inserted into the DOM
      // (the timeout is a best effort, as we don't know how long the WS notif + lazyload will take)
      setTimeout(() => this.scrollService.scrollToBottom(this), 1000);
    }
  }
}
